module.exports = __webpack_public_path__ + "media/images/process-home-624ac2cb21013fccfab2ba6cc5d35f70.svg";